// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3dqEk","productName":"Table_productName__51MG0"};